ready = ->
  $(window).scroll ->
    stickyHeader()

  fixFooter()

  $(window).resize ->
    fixFooter()

  if $('.alert').length > 0
    hideUnwantedFlashMessages()

  bootstrapFixes()
  setGrayLayoutBg()
  alertHeaders()
  previewSchool()
  currentUserHasPermission()
  return

window.closeAlertHeader = ->
  $('.view-school').removeClass('alert-wrapper')
  $('.alert-header').remove()

alertHeaders = ->
  alert_header_wrap_prepend = '<div class="alert-header">'
  alert_header_close_button = '<a class="close" href="javascript:void(0)" onclick="closeAlertHeader()">
    <i class="fa fa-times"></i>
  </a>'
  alert_header_wrap_append = '</div>'

  addAlertHeader = (text) ->
    $('.navbar-fedora').prepend(-> alert_header_wrap_prepend + text + alert_header_wrap_append)
    $('.view-school').addClass('alert-wrapper')

  # If school hasn't launched and admin is logged in, show them an alert header
  if not currentUser()?.schoolLaunched and currentUser()?.role is "owner"
    addAlertHeader('<div class="center-container green bolded">
        <center>Your school is not live yet. To launch your school, <a href="/admin">complete the remaining steps</a>.</center>
      </div>')
    $('.course-mainbar:not(.lecture-content)').css('margin-top', '42px')

previewSchool = ->
  current_url = location.origin + location.pathname

  if currentUser()?.preview is "logged_in"
    selected_logged_in = 'class="bold"'
    selected_logged_out = ''
    selected_admin = ''
  else if currentUser()?.preview is "logged_out"
    selected_logged_in = ''
    selected_admin = ''
    selected_logged_out = 'class="bold"'
  else if currentUser()?.preview is "admin"
    selected_logged_in = ''
    selected_logged_out = ''
    selected_admin = 'class=bold'

  view_school_nav = '<li class="dropdown">
    <a aria-expanded="false" aria-haspopup="true" class="fedora-navbar-link navbar-link dropdown-toggle" data-toggle="dropdown">
  Preview as
  <i class="caret"></i>
</a>
    <ul class="dropdown-menu">
      <li>
        <a href="' + current_url + '?preview=admin" ' + selected_admin + ' data-no-turbolink="true">
          Admin user
        </a>
      </li>
      <li>
        <a href="' + current_url + '?preview=logged_in" ' + selected_logged_in + ' data-no-turbolink="true">
          Logged in user
        </a>
      </li>
      <li>
        <a href="' + current_url + '?preview=logged_out" ' + selected_logged_out + ' data-no-turbolink="true">
          Logged out user
        </a>
      </li>
      </ul>
  </li>'

  # If school has launched and admin is logged in, show them a switch mode toggle
  if currentUserHasPermission()
    $('.navbar-nav li.dropdown:first').before(-> view_school_nav)


# Sticky header as you scroll
stickyHeader = ->
  if $(window).scrollTop() + $(window).height() > 450 + $(window).height()
    $("header #navbar").removeClass("is-at-top").removeClass("is-above-the-fold").addClass "is-scrolling"
  else if $(window).scrollTop() + $(window).height() > 100 + $(window).height()
    $("header #navbar").removeClass("is-scrolling").addClass "is-above-the-fold"
  else
    $("header #navbar").addClass("is-at-top").removeClass("is-above-the-fold").removeClass "is-scrolling"
  return

# Dynamically add padding to body on page load & resize to match the footer height
fixFooter = ->
  $('body').css('padding-bottom', $('footer').outerHeight())
  return

# Misc Bootstrap fixes
bootstrapFixes = ->
  $(".dropdown-menu").click (event) ->
    event.stopPropagation()
    return

setGrayLayoutBg = ->
  if $(".gray-layout").size() > 0
    grayBg = $(".gray-layout").css('background-color')
    $("body").css('background-color', grayBg)
  return

# These unwanted flash messages appear from time to time on signup / login forms
hideUnwantedFlashMessages = ->
  $(".alert:contains(You have signed up successfully)").hide()
  $(".alert:contains(Signed in successfully)").hide()
  $(".alert:contains(You need to sign in or sign up before continuing.)").hide()
  $(".alert:contains(Please update your password)").hide()
  $(".alert:contains(You are already signed in)").hide()

currentUserHasPermission = ->
  if currentUser()?.role == "owner" || currentUser()?.role == "author"
     return true
  else if   currentUser()?.role == "staff" || currentUser()?.customRoleCoursePermissions == true
    return true
  else
    return false

$(document).on("page:load ready", ready)
